const products = [
	{
		path: '/deals/products',
		name: 'shop-products-list',
		component: () => import('@/views/shop/products/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,product-suppliers',
		},
	},
]

export default products
